module.exports = __webpack_public_path__ + "ed7f982843dc1ecfc4880b0a612021d3.png";